import React from 'react';
import { FlatList } from 'react-native';
import { ContentBody } from '@annunciate/ui/dist/components/content/ContentBody';
import { View } from '../elements';
import { StickyHeader } from './StickyHeader';
export const Content = ({ content, isLoading = false, children, }) => {
    let StickyHeaderComponent;
    if (!!content?.cover?.src) {
        StickyHeaderComponent = React.createElement(StickyHeader, { uri: content?.cover?.src, isLoading: isLoading });
    }
    return (React.createElement(View, { style: { flexGrow: 1 } },
        React.createElement(FlatList, { data: [1], renderItem: () => (React.createElement(ContentBody, { content: content, isLoading: isLoading, children: children })), ListHeaderComponent: StickyHeaderComponent, onScrollToIndexFailed: () => { } })));
};
//# sourceMappingURL=Content.js.map